import { Board } from "@sportactics/board-editing";
import useSWR from "swr";

import { getSWRKey, SwrStore } from "~utils";

import { useFormationLocalPersistence } from "./formation-local-persistence";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useFormationsLocalSWR() {
  const fetcher = useFetcher();

  return useSWR(getFormationsLocalSWRKey(), fetcher, { suspense: true });
}

export function getFormationsLocalSWRKey(): FormationsLocalSWRKey {
  return getSWRKey(SwrStore.LocalFormations);
}

export type FormationsLocalSWRKey = readonly [SwrStore];

function useFetcher(): () => Promise<Record<string, Board>> {
  const { listFormations } = useFormationLocalPersistence();

  return () => listFormations();
}
